<template>
  <Modal
    :class-name="'comment-media'"
    :disabled="false"
    :modal-heading="heading"
    :modal-open="isOpen"
    :toggle-modal="() => toggleModal(false)"
  >
    <MediaGallery
      v-if="isOpen"
      :items="galleryItems"
      :show-thumbnails="true"
      :splide-options="{ start: startIndex }"
      :videos="videos"
    />
  </Modal>
</template>

<script>
  import Modal from "Components/Modal.vue";
  import { computed } from "vue";
  import { mapActions, mapGetters, mapState, useStore } from "vuex";
  import { useSingleCommentMedia } from "../composables/useSingleCommentMedia";
  import MediaGallery from "./MediaGallery.vue";

  export default {
    components: {
      MediaGallery,
      Modal,
    },

    computed: {
      ...mapState("modal", [
        "comment",
        "heading",
        "isOpen",
        "items",
        "startIndex",
      ]),
      ...mapGetters("global", ["isMobile"]),

      // The timeline hands the modal its own decade payload; otherwise the
      // images come from the comment that was clicked.
      galleryItems() {
        return this.items.length ? this.items : this.mediaItems;
      },
    },

    methods: mapActions({ toggleModal: "modal/toggle" }),
    name: "CommentViewModal",

    setup() {
      const store = useStore();
      const commentRef = computed(() => store.state.modal.comment || {});
      const { mediaItems, videos } = useSingleCommentMedia(commentRef);

      return { mediaItems, videos };
    },
  };
</script>
